import { render, staticRenderFns } from "./richText.module.vue?vue&type=template&id=6f543a54&scoped=true"
import script from "./richText.module.vue?vue&type=script&lang=js"
export * from "./richText.module.vue?vue&type=script&lang=js"
import style0 from "./richText.module.vue?vue&type=style&index=0&id=6f543a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f543a54",
  null
  
)

export default component.exports